module.exports = __webpack_public_path__ + "media/images/mainova-logo-5c88716fe7348530dd5f50152fbae18f.svg";